import React, { useEffect, useRef, useCallback } from 'react';
import Dialog from '../../common/components/Dialog';
import { useTranslations } from '../../localization/useTranslations';

type CancelDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onButtonClick: () => void;
};

const CancelDialog = ({ isOpen, onClose, onButtonClick }: CancelDialogProps) => {
  const dialogRef = useRef<HTMLDivElement>(null);

  const translations = useTranslations();

  const cancelDescription = window.forbes_my_account_subscription?.cancelSubscriptionModalContent || '';

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target as Node)) {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <Dialog isOpen={isOpen} onClose={onClose}>
      <div ref={dialogRef} className={`settings-modal modal modal--large`}>
        <div className="settings-modal__wrapper modal__wrapper">
          <div className="settings-modal__header modal__header">
            <h5 className="settings-modal__title archivo">
              {translations?.myAccountSubscription?.cancelSubscriptionTitle || 'Cancel Subscription'}
            </h5>

            <button className="close-button" onClick={onClose}></button>
          </div>
          <div className="settings-modal__content modal__content">
            <div dangerouslySetInnerHTML={{ __html: cancelDescription }} />
          </div>
        </div>
        <div className="settings-modal__footer modal__footer">
          <button className="link link--medium" onClick={onButtonClick}>
            OK
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default CancelDialog;
